import { SectionCard } from '../../../components/ui/SectionCard';
import { fmtAmount } from '../utils';

export function TopDebiteursCard({ stats, locale, t }) {
  const debiteurs = stats?.topDebiteurs ?? [];

  return (
    <SectionCard title={t('invoices.top_debiteurs')}>
      {debiteurs.length === 0 ? (
        <p className="text-[12.5px] text-slate-400 py-2">{t('invoices.top_debiteurs_empty')}</p>
      ) : (
        <div className="space-y-2.5">
          {debiteurs.map((d) => (
            <div key={d.name} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center flex-shrink-0">
                <span className="text-[11px] font-semibold text-slate-600">{d.initials}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[12.5px] font-medium text-slate-800 truncate">{d.name}</p>
                <p className="text-[11px] text-slate-400">
                  {t('invoices.top_debiteurs_count', { count: d.count })}
                </p>
              </div>
              <span className="text-[12.5px] font-semibold text-slate-800 tabular-nums flex-shrink-0">
                {fmtAmount(d.amount, 'EUR', locale)}
              </span>
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  );
}
